import { LensException } from "./LensException";

/**
 * Operation abort exception.
 */
export class AbortException extends LensException {
  /**
   * @param message Error message.
   */
  constructor(message: string) {
    super(message);
    this.name = "AbortException";
  }
}
